import $, { map } from "jquery";

function getOS() {
    if(/android/i.test(navigator.userAgent)) {
        return 'Android';
    }

    if(/iPad|iPhone|iPod/i.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)) {
        return 'iOS';
    }

    return 'Other';
}

const mapAddress = $('.footer_address');
$(mapAddress).on('click', function() {
    const os = getOS();

    if(os == "iOS") {
        window.open("http://maps.apple.com/?q=chassay+automobiles+tours", '_blank').focus();

    } else {
        window.open("https://www.google.com/maps/search/?api=1&query=chassay+automobiles+tours", '_blank').focus();

    }
});
